import moment from "moment";
import React from "react";
import { Card, Table } from "react-bootstrap";
import { RiFileTextLine } from "react-icons/ri";

function RecentInvoices({ invoices, invoicePagination, invoicePageHandler }) {
 
  const handleInvoiceClick = (url) => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

  return (
    <Card className="invoice-card">

      {/* HEADER */}
      <div className="invoice-header">
        <h6>Recent Invoices</h6>
        {/* <span className="view-all">View All</span> */}
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <Table borderless className="invoice-table align-middle">
          <tbody>
            {invoices?.length > 0 ? (
            invoices?.map((item, i) => (
              <tr key={i} className="border-bottom">

                {/* LEFT */}
                <td className="invoice-left">
                  <div onClick={() => handleInvoiceClick(item?.xeroInvoiceUrl)} className="d-flex align-items-center cursor-pointer">
                  <RiFileTextLine className="icons"  />
                  <span className="ms-2 ">
                    {item?.xeroInvoiceNumber || ""}
                    </span>
                    </div>
                </td>

                {/* DATE */}
                <td>
                  <span>{moment(item?.createdAt).local().format("MMM DD, YYYY")}</span>
                </td>

                {/* STATUS */}
                <td>
                  <span className={`status ${item?.invoiceStatus.toLowerCase()}`}>
                    {item?.invoiceStatus}
                  </span>
                </td>

                {/* AMOUNT */}
                <td className="text-end amount fw-semibold">
                  ${item?.totalAmount}
                </td>

              </tr>
            )) 
          ) : (
            <tr>
              <td colSpan={4} className="text-center py-4">
                No invoices found.
              </td>
            </tr>
          )}
          </tbody>
        </Table>
      </div>
        
      {/* FOOTER */}
      {/* <div className="invoice-footer">
        <button>View All Invoices</button>
      </div> */}

    </Card>
  );
}

export default React.memo(RecentInvoices);